import { type App, getCurrentInstance } from 'vue';
import { inject } from 'vue';

let globalProperties: App['_context']['config']['globalProperties'] | undefined;

export function useServices() {
  if (globalProperties) {
    return globalProperties;
  }

  const instance = getCurrentInstance();

  if (instance) {
    globalProperties = instance.appContext.config.globalProperties;
    return globalProperties;
  }

  const app = inject('extranetApp') as App | undefined;

  if (app?._context.config.globalProperties) {
    globalProperties = app._context.config.globalProperties;
  }

  if (globalProperties) {
    return globalProperties;
  }

  throw new Error('Vue instance is unavailable');
}
